import { render, staticRenderFns } from "./WriteBatchShippingModal.vue?vue&type=template&id=064352cb"
import script from "./WriteBatchShippingModal.vue?vue&type=script&lang=js"
export * from "./WriteBatchShippingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports